import { ETAB_ROUTES } from "@etab/config";

import { META_ALLOW_ANONYMOUS, META_FORCE_ANONYMOUS } from "@core/constants";
import CandidateReferencePage from './Candidate-reference.page.vue';

export default function() {
  return [{
    path: ETAB_ROUTES.candidateReference.path,
    name: ETAB_ROUTES.candidateReference.name,
    component: CandidateReferencePage,
    meta: { [META_ALLOW_ANONYMOUS]: true, [META_FORCE_ANONYMOUS]: false },
    beforeEnter(to, from, next) {
      const token = to.query.token;
      if (token) {
        next();
      } else {
        next({ name: ETAB_ROUTES.landing.name });
      }
    },
  }];
}
